import { Link } from "react-router-dom";
import { BtnInterface } from "../../interface/btn-interface";

const PrimaryTextBtn: React.FC<BtnInterface> = ({ to = '', children, type='button', fullWidth=true, className, disabled, onClick, onlyMobile, onlyDesktop, targetBlank }) => {
    let myClass = "btn-text-primary justify-center rounded-md transition shadow-sm text-sm/6 font-semibold py-1.5 px-3";
    if (onlyMobile) {
        myClass += ' flex md:hidden';
    } 
    else if (onlyDesktop) {
        myClass += ' hidden md:flex';
    } else {
        myClass += ' flex';
    }
    if (fullWidth) {
        myClass += ' w-full';
    }
    if (className) {
        myClass += ` ${className}`;
    }
    if (disabled) {
        myClass += ' opacity-50 pointer-events-none cursor-not-allowed';
    }

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        if (onClick) {
        onClick(event);
        }
    };

    if (to) {
        return (
            <Link
                to={to}
                className={myClass}
                tabIndex={disabled ? -1 : undefined}
                aria-disabled={disabled ? 'true' : undefined}
                onClick={disabled ? (e) => e.preventDefault() : undefined}
                target={targetBlank ? "_blank" : undefined}
                rel={targetBlank ? "noopener noreferrer" : undefined}
            >
                {children}
            </Link>
        );
    } else {
        return(
            <button
                type={type}
                className={myClass}
                disabled={disabled}
                onClick={handleClick}
            >
                {children}
            </button>
        )
    }
}
export default PrimaryTextBtn;
